export default {
      id: "ic-next-nextgen-home-horse-race-usage",
      viewBox: "0 0 20 24",
      url: "/" + "images/icons.3.109.2.svg#ic-next-nextgen-home-horse-race-usage",
      toString: function () {
        return this.url;
      }
    }